import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deletePackingSlipTemplate = {
  name: "deletePackingSlipTemplate" as const,
  input: z.object({ packingSlipId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
